/* Ported 1:1 from lib/app_constants.dart (FFAppConstants) and the magic
 * numbers scattered through custom_code/. Single source of truth for parity. */

/** FFAppConstants.appVersion — shown in the bottom-right badge as `v 0.0.21`. */
export const APP_VERSION = __APP_VERSION__

/** FFAppConstants.testAlarmId — the hardcoded alarm the landing button opens. */
export const TEST_ALARM_ID = '1y88XA2eMNR5kKd2bgSa'

/** FFAppConstants.testUserId — referenced by the dead /trackingCopy flow only. */
export const TEST_USER_ID = 'VyDH117yfcNiTydCIURT3FxPUoZ2'

/** FFAppState.testPossition default (sic) — Copenhagen; used in debug builds. */
export const TEST_POSITION = { lat: 55.693504, lng: 12.539031 }

/** Walk routes shorter than this render as dotted circles, not a polyline. */
export const MAX_DIST_CIRCLES_M = 20_000

/** Interpolation step for _getDottedPoints (metres). */
export const DOT_STEP_M = 12

/** Deviation from route that triggers a full recalc (metres). */
export const DEVIATION_M = 100

/** Geolocation polling interval (InstantTimer.periodic in the original). */
export const POLL_MS = 10_000

/** Fixed splash duration in main.dart — independent of auth resolution. */
export const SPLASH_MS = 1000

/** Auth debounce: a `null` emission is held this long when not logged in. */
export const AUTH_DEBOUNCE_MS = 1000

/** Cloud Functions region — every callable must pin this. */
export const FUNCTIONS_REGION = 'europe-west1'

/** Camera shift: target is pushed south by screenHeight/5 px (shiftLatLng). */
export const CAMERA_SHIFT_DIVISOR = 5

/** Initial map zoom. */
export const MAP_ZOOM = 14
